import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {withProps, withState} from 'recompose';
import fallback from 'assets/img/placeholderWhite.png';

const Img = styled('img')({
  width: 92,
  height: 'auto',
});

const ImageWithFallback = ({src, handleError, ...props}) => (
  <Img src={src} onError={handleError} {...props} />
);

ImageWithFallback.propTypes = {
  src: PropTypes.string.isRequired,
  handleError: PropTypes.func.isRequired,
};

export default ImageWithFallback
  |> withProps(({fallbackSrc = fallback, setSrc, errored, setErrored}) => ({
    handleError: () => {
      if (!errored && fallbackSrc) {
        setSrc(fallbackSrc);
        setErrored(true);
      }
    },
  }))
  |> withState('src', 'setSrc', ({src}) => src)
  |> withState('errored', 'setErrored', false);
